document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-travel-lists]');
  if (!root) return;

  const storageKey = 'furAndFarTravelListV1';
  const boxes = root.querySelectorAll('input[data-list-id]');
  let saved = {};
  try {
    saved = JSON.parse(localStorage.getItem(storageKey) || '{}') || {};
  } catch (error) {
    saved = {};
  }

  const persist = () => {
    const next = {};
    boxes.forEach((box) => {
      if (box.checked) next[box.dataset.listId] = true;
    });
    localStorage.setItem(storageKey, JSON.stringify(next));
    updateCount();
  };

  const updateCount = () => {
    const done = root.querySelectorAll('input[data-list-id]:checked').length;
    const total = boxes.length;
    const label = root.querySelector('[data-list-progress]');
    if (label) label.textContent = done + ' of ' + total + ' packed';
  };

  boxes.forEach((box) => {
    box.checked = Boolean(saved[box.dataset.listId]);
    box.addEventListener('change', persist);
  });

  const clear = root.querySelector('[data-list-clear]');
  if (clear) {
    clear.addEventListener('click', () => {
      boxes.forEach((box) => { box.checked = false; });
      persist();
    });
  }

  updateCount();
});
